import { CircleDot } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { riskClass } from "@/modules/collector_v2/lib/formatters";
import { riskLabels } from "@/modules/collector_v2/lib/constants";

export function RiskBadge({ level = "info", score, testid = "risk-badge" }) {
  return (
    <Badge data-testid={testid} variant="outline" className={`risk-badge ${riskClass(level)}`}>
      <CircleDot className="h-3 w-3" />
      {riskLabels[level] || level} {score !== undefined ? `· ${score}` : ""}
    </Badge>
  );
}
